import { differenceInMinutes } from 'date-fns';

type CalculateRetoolingProps = {
  startDate: Date;
  endDate: Date;
  setupEnd?: Date | string;
  nodeWidth: number;
};

export const calculateRetooling = (node?: CalculateRetoolingProps) => {
  return {
    isRetooling: !!node?.setupEnd && new Date(node?.setupEnd).getTime() !== new Date(node?.startDate).getTime(),
    retoolingWidth: node?.setupEnd
      ? calculateRetoolingWidth(node.startDate, node.endDate, new Date(node.setupEnd), node.nodeWidth)
      : 0,
  };
};

const calculateRetoolingWidth = (startDate: Date, endDate: Date, retoolingEndDate: Date, width: number) => {
  const totalDuration = differenceInMinutes(endDate, startDate);
  const retoolingDuration = differenceInMinutes(retoolingEndDate, startDate);

  const retoolingPercentage = (retoolingDuration / totalDuration) * 100;
  return (retoolingPercentage / 100) * width;
};
